var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ini-badge',_vm._b({class:['ini-badge', 'ini-badge__' + _vm.name, 'ini-badge--default ini-badge__' + _vm.name + '--' + _vm.transformToModifierClass(_vm.value) ]},'ini-badge',_vm.$props,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }